<template lang="pug">
div
  el-card(shadow="hover").card-container
    app-divider(label="Dados do VTN: ", :addMarginTop="false").margin-bottom
    div.center
      el-col(:span='8')
        el-row(:gutter="16")
          app-label.appLabel(label="Área requerida (ha):", :required="true")
          validation-provider(rules="required", v-slot="{ errors }")
            app-double-input.appInput(
              :hasValidationError="errors.length > 0",
              name='Área',
              :precision="4",
              :onkeypress="onlyInputNumbers",
              v-model="vtnRequest.areaRequerida",
            )
            span.help.erro {{ errors[0] }}
        el-row(:gutter="16")
          app-label.appLabel(label="Munícipio:", :required="true")
          el-input(
            v-model="vtnRequest.municipio.nome",
            :disabled="true"
          )
      el-col(:span='8')
        el-row(:gutter="16")
          validation-provider(rules="required", v-slot="{ errors }")
            app-label.appLabel(label="Nível:", :required="true")
            el-select(
              :class="{'erro' : errors.length}",
              v-model="vtnRequest.nivel",
            )
              el-option(
                v-for="(nivel) in niveis"
                :key="nivel.codigo",
                :label="nivel.nome",
                :value="nivel.codigo"
              )
            span.help.erro {{ errors[0] }}
        el-row(:gutter="16")
          app-label.appLabel(label="Valor de referência/Ha:", :required="true")
          div(class="el-input-group el-input-group--prepend appInput")
            app-double-input(
              v-model="valorReferencia",
              name='valorReferencia',
              :precision="2",
              :onkeypress="onlyInputNumbers",
              :disable="true"
            )
      el-col(:span='8')
        el-row(:gutter="16")
          app-label.appLabel(label="VTN:", :required="true")
          div(class="el-input-group el-input-group--prepend appInput")
            app-double-input(
              v-model="valorVtn",
              name='valorVtn',
              :precision="2",
              :onkeypress="onlyInputNumbers",
              :disable="true"
            )
        el-row(:gutter="16")
          app-label.appLabel(label="Valor de referência do imóvel:", :required="true")
          div(class="el-input-group el-input-group--prepend appInput")
            app-double-input(
              v-model="valorReferenciaImovel",
              name='valorReferenciaImovel',
              :precision="2",
              :onkeypress="onlyInputNumbers",
              :disable="true"
            )
    div.center
      el-col(:span='8')
        el-checkbox(v-model="vtnRequest.taxaDiversa") Taxas diversas (10% do valor do VTN)
</template>

<script>
import onlyInputNumbers from '@/components/mixins/OnlyInputNumber'
import AppLabel from '@/components/AppLabel'
import AppDoubleInput from '@/components/AppDoubleInput'
import AppDivider from '@/components/AppDivider.vue'
import AppDisplay from '@/components/AppDisplay'
export default {
  mixins: [onlyInputNumbers],
  components: {
    AppDivider,
    AppDisplay,
    AppLabel,
    AppDoubleInput
  },

  props: {
    vtnRequest: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      input: '',
      disable: true,
      temMunicipio: false,
      municipios: [],
      niveis: [{codigo: 'N1', nome: 'Nível 1'}, {codigo: 'N2', nome: 'Nível 2'}, {codigo: 'N3', nome: 'Nível 3'}, {codigo: 'N4', nome: 'Nível 4'}, {codigo: 'N5', nome: 'Nível 5'}]
    }
  },

  computed: {
    isAmapa () {
      return process.env.ESTADO === 'ap'
    },
    valorReferencia () {
      if (!this.vtnRequest || !this.vtnRequest.nivel || !this.vtnRequest.areaRequerida) return 0
      return this.vtnRequest.municipio.valorNivelMunicipio[this.vtnRequest.nivel.toLowerCase()]
    },
    valorReferenciaImovel () {
      if (!this.vtnRequest || !this.vtnRequest.nivel || !this.vtnRequest.areaRequerida) return 0
      return (this.vtnRequest.taxaDiversa ? this.valorVtn * 1.1 : this.valorVtn)
    },
    valorVtn () {
      if (!this.vtnRequest || !this.vtnRequest.nivel || !this.vtnRequest.areaRequerida) return 0
      return (this.valorReferencia * this.vtnRequest.areaRequerida)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/element-variables.scss";

.card-container {
  margin: 20px;
  border-radius: 10px;
}

.margin-bottom {
  margin-bottom: 20px;
}

.center {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 7%;
}
.flex {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: inherit;
}

.el-row {
  margin-bottom: 20px;
}

.flexRow{
  display: flex;
}

.appLabel {
  flex: 1;
}

.appInput {
  flex: 0.5;

  >>> .el-input__inner {
    border-radius: 4px !important;
  }
}

.el-input__inner {
  border-radius: 4px;
  font-size: 14px;
}

.el-input-group__append {
  color: $--color-text-regular
}

.erro {
  border-color: $--color-danger !important;
}

</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/components/InformarDadosMa.vue